import {useState} from "react";
import {withTranslation} from "react-i18next";

import {RawDialog} from "../InfoDialog";
import CopyToClipboardField from "../CopyToClipboardField";

import {Chip} from "@mui/material";

const LocationUUIDdialog = withTranslation()(({t, uuid}) => {
  const [dialogOpen, setDialogOpen] = useState(false)

  return (
    <>
      <Chip 
        label="uuid" 
        onClick={() => setDialogOpen(true)} 
        size="small"
        />
      <RawDialog
        dialogOpen={dialogOpen}
        data={{
          title: <>{t("location-uuid")}</>,
          hideOpenButton: true,
          hideDialogActionButtons: true,
          enableTitleCloseButton: true,
          okButtonText: "close",
          okButtonFunc: () => setDialogOpen(false),
          setDialogOpen,
        }}
      >
        {t('location-uuid-info')}
        <CopyToClipboardField text={uuid} />
      </RawDialog>
    </>
  )
})

export default LocationUUIDdialog;
